import {createModel} from '@rematch/core';

import {TProfile, TPromotionImage, getProfileByContacts} from '~/services/promotions';
import {CheckUrlResponseStatus, createCommonPromotion} from '~/services/hot-api/promotions';
import {PromotionTextTypes} from '~/utils/constants';

import type {RootModel} from '..';

export interface MainFormValues {
  url: string;
  displayUrl: string;
}

export type TopSpotPromotionState = {
  mainForm: MainFormValues;
  checkUrl: CheckUrlResponseStatus | null;
  profiles: TProfile[];
  selectedProfile: TProfile | null;
  images: TPromotionImage[];
  selectedLocations: number[];
  selectedCategories: number[];
  selectedThumbnail: TPromotionImage | null;
  bids: {
    cpc: string;
    daily: string;
  };
};

const defaultState: TopSpotPromotionState = {
  mainForm: {
    url: '',
    displayUrl: '',
  },
  checkUrl: null,
  profiles: [],
  images: [],
  selectedProfile: null,
  selectedLocations: [],
  selectedCategories: [],
  selectedThumbnail: null,
  bids: {
    cpc: '',
    daily: '',
  },
};

export const topSpotPromotion = createModel<RootModel>()({
  state: defaultState,
  reducers: {
    setPayload: (state: TopSpotPromotionState, payload: Partial<TopSpotPromotionState>) => ({
      ...state,
      ...payload,
    }),
  },
  effects: (dispatch) => {
    return {
      mainFormSubmit: async (values: MainFormValues) => {
        try {
          const {data} = await getProfileByContacts({profile_url: values.url});
          dispatch.topSpotPromotion.setPayload({
            profiles: data?.profiles || [],
            checkUrl: data.check_url_status,
          });

          return {
            isError: false,
            isSuccess: data.check_url.success,
            hasProfiles: data?.profiles.length > 0,
          };
        } catch (e) {
          console.error(e);

          return {
            isError: true,
            isSuccess: false,
            hasProfiles: false,
          };
        }
      },
      createPromotion: async (values: any) => {
        await createCommonPromotion({
          ...values,
          type: PromotionTextTypes.TopSpot,
        });
      },
    };
  },
});
